import { render, staticRenderFns } from "./billingDetails.vue?vue&type=template&id=1916602d&scoped=true"
import script from "./billingDetails.vue?vue&type=script&lang=js"
export * from "./billingDetails.vue?vue&type=script&lang=js"
import style0 from "./billingDetails.vue?vue&type=style&index=0&id=1916602d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1916602d",
  null
  
)

export default component.exports